.option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
